import React from 'react';

const Error = () => {
    return (
        <div>
            <h1>Этой страницы не существует!</h1>
        </div>
    );
};

export default Error;